// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YYKvKGjr_cCDvaarLxFQ{font-size:1.7em;margin-top:1rem}.XtWMJmDKxcRWyq_0N34L{margin-top:0;font-size:1.3rem}.HuQFgkqi2ycVWPJSDz4U{background-color:#f1f1f1}`, "",{"version":3,"sources":["webpack://./src/page-components/intent/generate-utterances.module.scss"],"names":[],"mappings":"AAAA,sBACE,eAAA,CACA,eAAA,CAGF,sBACE,YAAA,CACA,gBAAA,CAGF,sBACE,wBAAA","sourcesContent":[".title {\n  font-size: 1.7em;\n  margin-top: 1rem;\n}\n\n.description {\n  margin-top: 0;\n  font-size: 1.3rem;\n}\n\n.utteranceContainer {\n  background-color: #F1F1F1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `YYKvKGjr_cCDvaarLxFQ`,
	"description": `XtWMJmDKxcRWyq_0N34L`,
	"utteranceContainer": `HuQFgkqi2ycVWPJSDz4U`
};
export default ___CSS_LOADER_EXPORT___;
